import axios from 'axios';

const useSaveRowCalculations = () => {
  return async ({ estimateId, rows, overrideCost, avgPerFoot, avgPerRod, totalPercent }) => {
    if (!estimateId) throw new Error('Estimate ID is required.');

    const payload = rows.map((row) => ({
      estimateId,
      county: row.county || '',
      footage: Number(row.footage) || 0,
      costPerFoot: Number(row.costPerFoot) || 0,
      percentOfRoute: parseFloat(row.percentOfRoute || '0'),
      totalCost: Number(row.totalCost) || 0,
    }));

    await axios.put(
      `/api/PipelinePricing/pipeline/update-row-calculations/${estimateId}`,
      {
        estimateId,
        rows: payload,
        overrideCost,
        avgPerFoot,
        avgPerRod,
        totalPercent,
      },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
  };
};

export default useSaveRowCalculations;
